import ModuleFullWidthContainer from './ModuleFullWidthContainer';

export default ModuleFullWidthContainer;
export * from './ModuleFullWidthContainer';
